/**
 * localStorage key backing the one-time "Keep Me Signed In" post-login nudge.
 * Presence of the key (any value) means the nudge has already been shown in
 * this browser and must never show again.
 */
export const KMSI_NUDGE_SEEN_KEY = 'connect-kmsi-nudge-seen';

/** Copy for the one-time nudge shown after an untrusted (non-KMSI) login. */
export const KMSI_NUDGE_MESSAGE =
  'Tired of logging in? You can stay signed in on your own device — turn it on in Settings.';

/**
 * Whether the KMSI nudge has already been shown in this browser.
 *
 * Backed by localStorage rather than a session-scoped flag so the nudge is a
 * true once-ever-per-browser affordance, not once-per-login. Storage errors
 * (e.g. privacy mode) are swallowed and treated as "already seen" so a broken
 * localStorage can't turn this into a nudge shown on every login.
 */
export function hasSeenKmsiNudge(): boolean {
  try {
    return localStorage.getItem(KMSI_NUDGE_SEEN_KEY) !== null;
  } catch {
    return true;
  }
}

/**
 * Marks the KMSI nudge as seen so it never shows again in this browser.
 *
 * Called whenever the nudge is dismissed and when its "Go to Settings"
 * affordance is used — either path means the user has now been told the
 * setting exists, so neither should leave the nudge eligible to reappear.
 */
export function markKmsiNudgeSeen(): void {
  try {
    localStorage.setItem(KMSI_NUDGE_SEEN_KEY, 'true');
  } catch {
    // Storage unavailable — ignore; worst case the nudge can reappear.
  }
}
